import { render, staticRenderFns } from "./FAQContact.vue?vue&type=template&id=bb784b48&scoped=true"
import script from "./FAQContact.vue?vue&type=script&lang=js"
export * from "./FAQContact.vue?vue&type=script&lang=js"
import style0 from "./FAQContact.vue?vue&type=style&index=0&id=bb784b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb784b48",
  null
  
)

export default component.exports